import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState } from 'react';
import { Button, Grid } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import { ItemAdjustment } from '../../../../../../domains/checkout/CartSummary/CartSummary.propTypes';
import { formatCurrency } from '../../../../../../utils/currency';
import './PriceChangeAdjustment.css';
var defaultProps = {};
export default function PriceChangeAdjustment(_ref) {
  var adjustment = _ref.adjustment,
    onRemoveItemProp = _ref.onRemoveItem;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var oldValue = adjustment.old_value,
    newValue = adjustment.new_value,
    description = adjustment.description;
  function onRemoveItem() {
    return _onRemoveItem.apply(this, arguments);
  }
  function _onRemoveItem() {
    _onRemoveItem = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setLoading(true);
            _context.next = 4;
            return onRemoveItemProp();
          case 4:
            _context.prev = 4;
            setLoading(false);
            return _context.finish(4);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0,, 4, 7]]);
    }));
    return _onRemoveItem.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(Grid, {
    className: "price-change-adjustment",
    stackable: true
  }, /*#__PURE__*/React.createElement(Grid.Column, {
    className: "old-price",
    width: 6,
    textAlign: "right"
  }, /*#__PURE__*/React.createElement("div", null, formatCurrency(+oldValue), " ")), /*#__PURE__*/React.createElement(Grid.Column, {
    className: "new-price",
    width: 10,
    textAlign: "right"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "price"
  }, "Now ", formatCurrency(newValue)), !_isEmpty(description) && /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, description), /*#__PURE__*/React.createElement(Button, {
    loading: loading,
    disabled: loading,
    content: "Remove item",
    onClick: onRemoveItem
  }))));
}
PriceChangeAdjustment.defaultProps = defaultProps;